import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import classNames from 'classnames/bind';
import styles from './Terms.module.css';

import {
  settingsApiSlice,
  useGetSettingsTermsQuery,
} from '../../../services/settings';

import {
  EFFECTIVE_DATE,
  PREV,
  PRIVACY_POLICY,
  TERMS,
  VIEW,
} from '../../../constants';
import { Terms as ITerms } from '../../../types/common';
import { formatDate } from '../../../utils/date';

export default function Terms() {
  const cx = classNames.bind(styles);
  const location = useLocation();
  const agreeCd = location.pathname.includes('terms') ? 'T0101' : 'T0102';
  const { data, isLoading } = useGetSettingsTermsQuery(agreeCd);
  const [getPrevTerms] = settingsApiSlice.useLazyGetPrevTermsQuery();
  const [isShowPrevTerms, setIsShowPrevTerms] = useState(false);
  const [prevTermsData, setPrevTermsData] = useState<ITerms>();
  const typeStr = agreeCd === 'T0101' ? TERMS : PRIVACY_POLICY;

  if (isLoading) return null;

  const { content, dispStartDate, prevYn } = data;
  const renderedHtml = {
    __html: isShowPrevTerms
      ? prevTermsData?.content
          .replaceAll('--urlSpellingErrorV2,', '')
          .replaceAll('--urlContextualSpellingAndGrammarErrorV2', '')
      : content
          .replaceAll('--urlSpellingErrorV2,', '')
          .replaceAll('--urlContextualSpellingAndGrammarErrorV2', ''),
  };

  const showPrevTerms = async () => {
    try {
      const terms = await getPrevTerms(data.agreeCd, true).unwrap();
      setPrevTermsData(terms);
      setIsShowPrevTerms(true);
    } catch (error) {
      console.error('Failed to get previous terms', error);
    }
  };

  return (
    <>
      <h2>{typeStr}</h2>
      <div className={cx('agreement_version')}>
        {!!prevYn && !isShowPrevTerms && (
          <div className={cx('link_t')} onClick={showPrevTerms}>
            <span>
              {PREV} {typeStr} {VIEW}
            </span>
          </div>
        )}
        <p>
          {EFFECTIVE_DATE}:{' '}
          {formatDate(
            isShowPrevTerms ? prevTermsData?.dispStartDate : dispStartDate
          )}
        </p>
      </div>
      <div
        className={cx('agreement_area')}
        dangerouslySetInnerHTML={renderedHtml}
      ></div>
    </>
  );
}
